import React from 'react';
import './BottleLoader.scss';

const BottleLoader = () => {
  return (
    <div className="bottle-loader">
      <section className="loader">
        <div className="slider" style={{'--i': 0}} />
        <div className="slider" style={{'--i': 1}} />
        <div className="slider" style={{'--i': 2}} />
        <div className="slider" style={{'--i': 3}} />
        <div className="slider" style={{'--i': 4}} />
      </section>
      <p className="loading-text">Finding products near you...</p>
    </div>
  );
};

export default BottleLoader;
